import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Featured", href: "#featured" },
  { label: "Home Value", href: "#home-value" },
  { label: "Listings", href: "#listings" },
  { label: "Reviews", href: "#reviews" },
  { label: "Blog", href: "/blog" },
  { label: "Find Your Agent", href: "#quiz" },
  { label: "About Melissa", href: "#bio" },
  { label: "Contact", href: "#contact" }
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/70 backdrop-blur-2xl backdrop-saturate-150 border-b border-black/5" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="flex flex-col leading-none">
          <span className={`font-heading text-xl md:text-2xl tracking-tight transition-colors ${scrolled ? "text-[#0a0a0a]" : "text-white"}`}>Melissa O'Donnell</span>
          <span className={`eyebrow text-[10px] mt-1 transition-colors ${scrolled ? "text-[#0a0a0a]" : "text-white"}`}>Real Estate Group</span>
        </a>

        <div className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className={`text-sm font-light transition-colors hover:text-gold ${scrolled ? "text-[#0a0a0a]" : "text-white"}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quiz"
            data-testid="nav-cta"
            className={`text-sm px-6 py-3 transition-colors ${scrolled ? "bg-[#0a0a0a] text-white hover:bg-[#27272a]" : "bg-white text-[#0a0a0a] hover:bg-gold hover:text-white"}`}
          >
            Get Started
          </a>
        </div>

        <button
          className={`lg:hidden transition-colors ${scrolled ? "text-[#0a0a0a]" : "text-white"}`}
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-black/5 px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
              className="text-base font-light text-[#0a0a0a]"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
